import Hls, {
  HlsConfig,
  LoaderCallbacks,
  LoaderConfig,
  LoaderContext,
  LoaderResponse,
  LoaderStats,
} from 'hls.js';

/**
 * Aggressive playlist loader that modifies M3U8 playlists to force faster updates.
 * This class wraps the default loader and modifies the TARGETDURATION value
 * to make HLS.js reload playlists more frequently.
 */
export class AggressivePlaylistLoader extends (Hls.DefaultConfig.loader as any) {
  constructor(config: HlsConfig) {
    super(config);
  }

  load(
    context: LoaderContext & { type: 'manifest' | 'level' },
    config: LoaderConfig,
    callbacks: LoaderCallbacks<LoaderContext>,
  ) {
    // We only care about playlist/manifest requests
    if (context.type === 'manifest' || context.type === 'level') {
      const originalOnSuccess = callbacks.onSuccess;

      // Wrap the success callback to modify data before HLS.js sees it
      callbacks.onSuccess = (
        response: LoaderResponse,
        stats: LoaderStats,
        context: LoaderContext,
        networkDetails: any,
      ) => {
        if (typeof response.data === 'string') {
          // HACK: Rewrite TargetDuration from 31 to 10
          // This forces HLS.js to schedule the next reload in ~10 seconds
          // instead of ~31 seconds.
          response.data = response.data.replace(
            /#EXT-X-TARGETDURATION:\d+/,
            '#EXT-X-TARGETDURATION:10',
          );
        }
        originalOnSuccess(response, stats, context, networkDetails);
      };
    }

    // Call the original loader logic
    super.load(context, config, callbacks);
  }
}
